import { handleResponse, Headers } from '../_helpers';

export const WorldService = {
  getSubGroups,
};

function getSubGroups(worldID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/world/${worldID}/subgroups`,
    request
  )
    .then(handleResponse)
    .then((response) => {
      // console.log('World Subscriber Groups:', response);
      return response;
    });
}
